import { BaseFiltroInputDto } from "./base-filtro.input.dto";

export class PesquisaBasicaJornalInputDto extends BaseFiltroInputDto {
  public textoPesquisa: string;
  public dataPublicacaoInicial: Date;
  public dataPublicacaoFinal: Date;
  public diarioExecutivo?: boolean;
  public diarioMunicipios?: boolean;
  public diarioTerceiros?: boolean;
  public edicaoExtra?: boolean;
  public diarioJudiciario?: boolean;
  public diarioLegislativo?: boolean;

  constructor(
    termo: string, dataPublicacaoInicial: Date, dataPublicacaoFinal: Date,
    diarioExecutivo: boolean, diarioMunicipios: boolean,
    diarioTerceiros: boolean, edicaoExtra: boolean,
    diarioJudiciario: boolean, diarioLegislativo: boolean,
    paginaAtual: number, tamanhoPagina: number
  ){
      super(paginaAtual, tamanhoPagina);
      this.textoPesquisa = termo;
      this.dataPublicacaoInicial = dataPublicacaoInicial;
      this.dataPublicacaoFinal = dataPublicacaoFinal;
      this.diarioExecutivo = diarioExecutivo;
      this.diarioMunicipios = diarioMunicipios;
      this.diarioTerceiros = diarioTerceiros;
      this.edicaoExtra = edicaoExtra;
      this.diarioJudiciario = diarioJudiciario;
      this.diarioLegislativo = diarioLegislativo;
  }
}
